export enum ActionTypes {
  SET_GOOGLE_MAPS_IS_LOADED = 'SET_GOOGLE_MAPS_IS_LOADED'
}
